<template>
  <div id="app">
    <!-- <transition :name="transitionName"> -->
    <navigation>
      <router-view class="router" />
    </navigation>
    <!-- </transition> -->
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      // transitionName: 'van-slide-left'
      transitionName: ''
    }
  },
  created() {
    this.$navigation.on('forward', () => {
      // this.transitionName = 'van-slide-left'
    })
    this.$navigation.on('back', () => {
      // this.transitionName = 'van-slide-right'
    })

    window.onload = function () {
      document.addEventListener('touchstart', function (event) {
        if (event.touches.length > 1) {
          event.preventDefault()
        }
      })
      document.addEventListener('gesturestart', function (event) {
        event.preventDefault()
      })
    }
    // 加载京通sdk
    this.$loadSdk({
      success: async (jtsdk) => {
        console.log("🚀 ~ created ~ jtsdk:", jtsdk)
      }
    })
  }
};

!(function (t) {
  function e() {
    var e = this || self;
    (e.globalThis = e), delete t.prototype._T_;
  }
  "object" != typeof globalThis &&
    (this
      ? e()
      : (t.defineProperty(t.prototype, "_T_", {
        configurable: !0,
        get: e,
      }),
        _T_));
})(Object);

</script>

<style lang="scss">
@import "App.scss";
html,
body {
  height: 100%;
  background: #fbfbfb;
}
* {
  margin: 0;
  padding: 0;
}
#app {
  height: 100%;
  position: relative;
}
body {
  width: 100%;
  height: 100%;
  /* 设计稿最大宽度 */
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
/* 网签中心表单大标题 */
.signcenter_form_big_title {
  color: #333333;
  font-size: 36px;
  padding: 20px 30px;
  font-weight: 700;
}
.stl {
  padding-top: 10px;
}

/* 数据列表为空占位图 */
// .emptyBox {
//   width: 100%;
//   height: 600px;
//   background: url("~@/assets/empty.png") no-repeat;
//   background-size: cover;
// }

/* 全局表单label样式 */
.van-field__label {
  color: #b9b9b9;
}
/* 全局表单项分割线样式 */
.van-cell::after {
  border-color: #d7d7d7;
}
/* 全局cell样式 */
.van-cell {
  padding: 30px;
  align-items: center;
  align-content: center;
}
.van-pull-refresh {
  overflow: unset !important;
  min-height: 65vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue